// Layers whose features own a click (they open their own bubble or popup): facility
// points, deal pins, interactive user layers and interactive library layers. The
// data (choropleth) layers are deliberately not in this list.
export default function interactiveFeatureLayerIds(mapData, mapInstance) {
    const ids = [mapData.geoJsonLayersData.pointsLayerId];

    if (mapData.dealListPinsData && mapData.dealListPinsData.layerId) {
        ids.push(mapData.dealListPinsData.layerId);
    }

    mapData.userDataLayersData.layers.forEach(dl => {
        if (dl.metadata.userData && dl.metadata.userData.interactive) ids.push(dl.id);
    });

    mapInstance.libraryDataLayers.forEach(layerGroup => {
        if (!layerGroup.metadata.interactivity) return;
        layerGroup.layersDefinition.forEach(layer => {
            const layerMetadata = layer.metadata.socialexplorer;
            if (layerMetadata.interactivity && layerMetadata.interactivity.enabled)
                ids.push(layer.id);
        });
    });

    return ids;
}
